import React, { useEffect, useState, useMemo } from 'react';
import { CommonUtil } from "../../utils/CommonUtil";
import SingleSelectComp from "../../Components/SingleSelectComp";
import { NetworkManager } from "../../Components/NetworkManager";
import AGGrid from "../../Components/AGGrid";
import ReservationDetailsCellRenderer from "../Organization/ReservationDetailsCellRenderer";
import EquipCellRenderer from "../Organization/EquipCellRenderer";
import { Events } from "../Languages/Events";
import DetectDevice from '../../utils/DetectDevice';
import MGrid from '../../Components/MGrid';
import { Constants } from "../Languages/Constants";
import ImageModal from "../../Components/ImageModal";
import Confirm from '../../Components/confirm';
import ToastManager from '../../Components/ToastManager';

const defObj = { key: '', value: 'All' };

const DamageReport = () => {
    const { isMobile } = DetectDevice();
    const [orgData, setOrgData] = useState<any>(null);
    const [isCompanyVisible, setCompanyVisible] = useState(CommonUtil.isRootUser());
    const [selCompanyObj, setSelCompanyObj] = useState<any>({ orgId: null, orgName: "All" });
    const [reservationList, setReservationList] = useState<any>([]);
    const [reserveObj, setReservationObj] = useState<any>(defObj);

    const [reservationCode, setReservationCode] = useState("");

    let onLoginError = (err:any)=>{
        console.log(err);
    }
    // State for filtering buttons
    const [filters, setFilters] = useState({
        isProgress: true,
        isDeActivationDue: true,
        isDone: true
    });
    
    const [startIndex, setStartIndex] = useState<number>(0);
    const [imageSrcs, setImageSrcs] = useState<any[]>([]);
    
    // State for Image Popup
    const [showImagePopup, setShowImagePopup] = useState(false);
    // const [selectedImage, setSelectedImage] = useState<string>('');
    const [imgByDocType, setImgByDocType] = useState<Record<string, string>>({});

    // Image Count Renderer
    const ImageCountRenderer = (params: any) => {
        const images = params.data?.imagePath || [];
        const count = images.length;
        
        if (count === 0) return null;

        return (
            <div 
                style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }} 
                onClick={() => handleImageClick(images)}
            ><span className="picture-icon" role="button">
                  <span className="position-relative">
                    <img
                      src="../../images/picture.svg"
                      alt="Task"
                      className="task-picture"
                    />
                    <span className="position-absolute top-0 mt-1 start-100 translate-middle badge rounded-pill bg-primary">
                      {count}
                      <span className="visually-hidden">unread messages</span>
                    </span>
                  </span>
                </span>
            </div>
        );
    };

    const handleImageClick = (images: any[]) => {
        const imageArray = images.map((imgItem: any) => ({
             original: imgByDocType[imgItem.imagePath || imgItem.url || imgItem] || (imgItem.imagePath || imgItem.url || imgItem),
             key: imgItem.imagePath || imgItem.url || imgItem,
             comment: imgItem.comment || "",
         }));
         setImageSrcs(imageArray);
         const preparedImages = images.map((img:any) => img.imagePath || img.url || img);
         setImageSrcs(preparedImages);
         setShowImagePopup(true);
         setStartIndex(0);
    };

    let handleDeleteDamageReport = (id:any) => {
      Confirm.show("Confirm", "Would you like to delete this damage report?", [
        {
          label: "Delete",
          callback: function () {
            let removeAPI: string = `api/reservation/deleteDamageImages?reservationId=${id}`;
            NetworkManager.sendJsonRequest(removeAPI, "", "", "POST", true, (dataObj: any) => {
                const restData = CommonUtil.parseData(dataObj);
                if (!restData.errorMessage) {
                  getDamagedReports();
                  ToastManager.showToast("Damage report deleted successfully", "Info");
                }else{
                  ToastManager.showToast(restData.errorMessage, "Error");
                }
              }, onLoginError);
          }
        },
        { label: "Cancel" },
      ]);
    }
    
    const deleteDamageReport = (params: any) => {
        return (
            <div style={{ cursor: 'pointer' }} >
                <span title="Delete" className="ms-2 p-1" onClick={() => handleDeleteDamageReport(params.data.reservationId)}
                  style={{
                      color: "red",
                      cursor: "pointer",
                  }}
                >
                <svg id="fi_6861362" height="16" viewBox="0 0 512 512" width="16" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="m170.8 14.221a14.21 14.21 0 0 1 14.2-14.207l141.991-.008a14.233 14.233 0 0 1 14.2 14.223v35.117h-170.391zm233.461 477.443a21.75 21.75 0 0 1 -21.856 20.33h-254.451a21.968 21.968 0 0 1 -21.854-20.416l-21.774-318.518h343.174l-23.234 318.6zm56.568-347.452h-409.658v-33a33.035 33.035 0 0 1 33.005-33.012l343.644-.011a33.051 33.051 0 0 1 33 33.02v33zm-270.79 291.851a14.422 14.422 0 1 0 28.844 0v-202.247a14.42 14.42 0 0 0 -28.839-.01v202.257zm102.9 0a14.424 14.424 0 1 0 28.848 0v-202.247a14.422 14.422 0 0 0 -28.843-.01z" fill="#fc0005" fill-rule="evenodd"></path></svg>
                </span>
            </div>
        );
    };

    const damageColumns = useMemo(() => [
        { field: 'reservationStatus', headerName: CommonUtil.getMessageText(Constants.STATUS, "Status"), resizable: true, width: 210, sortable: true, filter: 'agTextColumnFilter'},
        { field: 'reservationCode', headerName: CommonUtil.getMessageText(Constants.RESERVATION_ID, "Reservation Id"), resizable: true, flex: 1, width: 200, sortable: true, filter: 'agTextColumnFilter', cellRenderer: ReservationDetailsCellRenderer },
        { field: 'images', headerName: "Images", resizable: true, flex: 1, width: 100, cellRenderer: ImageCountRenderer },
        { field: 'UnitEquipName', headerName: CommonUtil.getMessageText(Constants.EQUIP_NO_NAME, "Equipment Number / Name"), flex: 1, resizable: true, sortable: true, filter: 'agTextColumnFilter', cellRenderer: EquipCellRenderer },
        { field: 'equipmentType', headerName: CommonUtil.getMessageText(Constants.EQUIP_TYPE, "Equipment Type"), resizable: true, flex: 1, width: 200, sortable: true, filter: 'agTextColumnFilter' },
        { field: 'brand', headerName: CommonUtil.getMessageText(Constants.BRAND, "Brand"), resizable: true, flex: 1, width: 100, sortable: true, filter: 'agTextColumnFilter' },
        { field: 'year', headerName: CommonUtil.getMessageText(Constants.YEAR, "Year"), resizable: true, width: 100, sortable: true, filter: 'agTextColumnFilter' },
        { field: 'reservationType', headerName: CommonUtil.getMessageText(Constants.RESERVATION_TYPE, "Reservation Type"), flex: 1, resizable: true, width: 200, sortable: true, filter: 'agTextColumnFilter' },
        { field: 'VIN', headerName: CommonUtil.getMessageText(Constants.VIN, "VIN"), resizable: true, flex: 1, width: 100, sortable: true, filter: 'agTextColumnFilter' },
        { field: 'renterName', headerName: CommonUtil.getMessageText(Constants.RENTER_NAME, "Renter Name"), flex: 1, resizable: true, width: 200, sortable: true, filter: 'agTextColumnFilter' },
        { field: 'owner', headerName: "Owner Name", flex: 1, resizable: true, width: 200, sortable: true, filter: 'agTextColumnFilter' },
        { field: 'action', headerName: CommonUtil.getMessageText(Constants.ACTION, "Action"), resizable: true, width: 100, sortable: true, filter: 'agNumberColumnFilter', cellRenderer: deleteDamageReport }
    ], []);

    const onCompanyChange = (dataObj: any) => {
        setSelCompanyObj(dataObj);
    };

    const onStatusChange = (dataObj: any) => {
        if (dataObj) {
            setReservationObj(dataObj);
        } else {
            setReservationObj(defObj);
        }
    };

    const onReservationCodeChange = (e: any): void => {
        setReservationCode(e.currentTarget.value);
    };

    const onSuccessOffers = (dataObj: any) => {
        var equips: any[] = [];
        if (dataObj) {
            var restData = CommonUtil.parseData(dataObj);
            if (restData) {
                if (Array.isArray(restData)) {
                    equips = restData;
                } else {
                    equips.push(restData);
                }
                equips.forEach((item: any) => {
                    if (item.isGeneric) {
                        item.isGeneric = item.isEquipmentGeneric === "Y" ? CommonUtil.EQUIP_GENERIC : CommonUtil.EQUIP_SPECIFIC;
                        if (item.isEquipmentGeneric === "Y" && item.isEnableAnyAvailble === "Y") {
                            item.isGeneric = item.isGeneric + " - " + CommonUtil.ANY_AVAILABLE;
                        }
                    }
                    item.UnitEquipName = (item.unitNumber ? item.unitNumber : item.genericEquipmentName);

                    if (item.isInsurancePaidByRenterLiability === "Y") {
                        item.liabilityPaidBy = CommonUtil.RENTER;
                    } else if (item.isInsurancePaidByOwnerLiability === "Y") {
                        item.liabilityPaidBy = CommonUtil.OWNER;
                    }

                    if (item.isInsurancePaidByRenterPhysical === "Y") {
                        item.damageInsurancePaidBy = CommonUtil.RENTER;
                    } else if (item.isInsurancePaidByOwnerPhysical === "Y") {
                        item.damageInsurancePaidBy = CommonUtil.OWNER;
                    }
                });

                setReservationList(equips);
            }
        }
    };

    const toggleFilter = (filterName: keyof typeof filters) => {
        setFilters(prev => ({ ...prev, [filterName]: !prev[filterName] }));
    };

    const getButtonStyle = (isActive: boolean) => {
        const baseStyle: React.CSSProperties = {
            border: '1px solid #e4e4e4',
            borderRadius: '15px',
            marginTop: '5px',
            color: 'black'
        };

        if (isActive) {
            return {
                ...baseStyle,
                background: '#23D2C1',
                boxShadow: 'none'
            };
        } else {
            return {
                ...baseStyle,
                background: 'white',
                boxShadow: '1px 2px #e4e4e4'
            };
        }
    };

    const getDamagedReports = () => {
      let qParam = selCompanyObj?.orgId ? selCompanyObj.orgId : "";
      if (!CommonUtil.isRootUser()) {
          qParam = CommonUtil.getSaasOrgId();
      }
      
      let usrUrl = "api/reservation/all";
      let statusList: string[] = [];

      if (filters.isProgress) statusList.push("In progress");
      if (filters.isDone) statusList.push("Done");
      if (filters.isDeActivationDue) statusList.push("Deactivation Due");

      if (statusList.length === 0) {
        statusList = [""];
        setReservationList([]);
        return;
      }

      let payload: any = { isAll: qParam ? false : true, isForDamage: true, companyId: qParam, reservationCode: String(reservationCode).trim(), multipleStatus: statusList };

      if (qParam === "") delete payload.companyId;
      
      NetworkManager.sendJsonRequest(usrUrl, payload, '', "POST", true, onSuccessOffers, () => {});
    };

    useEffect(() => {
        // Optimize: Rely on state filters instead of global vars reset
        CommonUtil.SCREEN_NAME = CommonUtil.OWNER_RESERVATION; // Or Constants.DAMAGE_REPORT if applicable
        document.addEventListener(Events.SWITCH_CUSTOMER_EVENT, onSwitchCustomer);
        
        // Initial Fetch
        getDamagedReports();

        CommonUtil.getAllAssetTypes((data: any) => {
            CommonUtil.ASSET_TYPES = data;
        });

        if (CommonUtil.isRootUser()) {
            CommonUtil.getAllOrgs((data: any) => {
                let arr = [{ orgId: null, orgName: "All" }];
                setOrgData([...arr, ...data]);
            });
        }

        return () => {
            document.removeEventListener(Events.SWITCH_CUSTOMER_EVENT, onSwitchCustomer);
        };
    }, []); // Run once on mount

    // Re-fetch when filters or company changes
    useEffect(() => {
        getDamagedReports();
    }, [filters, selCompanyObj]);


    const onSwitchCustomer = () => {
        setCompanyVisible(CommonUtil.isRootUser());
        if (CommonUtil.isRootUser()) {
            CommonUtil.getAllOrgs((data: any) => {
                let arr = [{ orgId: null, orgName: "All" }];
                setOrgData([...arr, ...data]);
            });
            setSelCompanyObj({ orgId: null, orgName: "All" });
        } else {
            getDamagedReports();
        }
        Events.dispatchBreadCrumbEvent();
    };


    const onClickDetail = (data: any) => {
        // Handle detail click if needed
    };

    return (
        <>
            <div className={'container-fluid'} style={{ paddingLeft: "15px", paddingRight: "15px" }}>
                <div className="row">
                    <div className="col-md-2 col-12 pt-2" style={{ paddingLeft: '5px', zIndex: 999, display: (isCompanyVisible ? "" : "none") }}>
                        <span className="black-text css-16ihq8s">{CommonUtil.getMessageText(Constants.COMPANY, "Company")}</span>
                        <SingleSelectComp dataSource={orgData} selectedValue={selCompanyObj}
                            width={'100%'} handleChange={onCompanyChange}
                            value={'orgId'} label={'orgName'} />
                    </div>
                    <div className="col-md-2 col-6 pt-1" style={{ zIndex: '98', display: "none" }}>
                        <span className="black-text css-16ihq8s">{CommonUtil.getMessageText(Constants.STATUS, "Status")}</span>
                        <SingleSelectComp dataSource={CommonUtil.RESERVATION_STATUSES} selectedValue={reserveObj}
                            handleChange={onStatusChange} width={'100%'} value={'key'} label={'value'} />
                    </div>

                    <div className="col-md-2 col-6 pt-2" style={{ zIndex: '97' }}>
                        <span className="black-text css-16ihq8s">Reservation Code</span>
                        <input type="text" className="form-control "
                            required={true} placeholder="Reservation Code"
                            value={reservationCode} onChange={(e) => {
                                onReservationCodeChange(e);
                            }} />
                    </div>

                    <div className="col-md-12 col-lg-1 row">
                        <div className="col-md-1" style={{ paddingTop: (isCompanyVisible ? "7px" : '7px') }}>
                            <span className="black-text css-16ihq8s" style={{ visibility: "hidden" }}> dsdd</span>
                            <button type="button" className="btn btn-warning cus-btn btn-sm button-height"
                                onClick={getDamagedReports}>
                                {CommonUtil.getMessageText(Constants.SEARCH, "Search")}
                            </button>
                        </div>
                    </div>
                </div>

                <div className="row" style={{ paddingTop: "15px" }}>
                    <button type="button" className="btn button-height" style={getButtonStyle(filters.isProgress)} onClick={() => toggleFilter('isProgress')}>
                        {"In progress"}
                    </button>
                    &nbsp;
                    &nbsp;
                    <button type="button" className="btn button-height" style={{ ...getButtonStyle(filters.isDeActivationDue), width: "180px" }} onClick={() => toggleFilter('isDeActivationDue')}>
                        {"Deactivation Due"}
                    </button>
                    &nbsp;
                    <button type="button" className="btn button-height" style={getButtonStyle(filters.isDone)} onClick={() => toggleFilter('isDone')}>
                        {"Done"}
                    </button>
                </div>
                <div className={`row ${isMobile ? '' : 'pt-3'}`}>
                    {
                        isMobile ? (
                            <MGrid id="damageReportList-m" cols={damageColumns} rows={reservationList} pageSize={10}
                                addNew={false} tooltip={"Offers"}
                                headerHeight={35} rowHeight={40} method={{ onClickDetail }}
                                suppressRowClickSelection={true} />
                        ) : (
                            <div className="ag-theme-alpine gridHeight" style={{ height: (isCompanyVisible ? "calc(100vh - 240px)" : "calc(100vh - 210px)"), width: "100%" }}>
                                <AGGrid id="damageReportList" cols={damageColumns} rows={reservationList} pageSize={500}
                                    addNew={false} tooltip={"Offers"}
                                    headerHeight={35} rowHeight={40} method={{ onClickDetail }}
                                    suppressRowClickSelection={true} />
                            </div>
                        )
                    }
                </div>
            </div>
            {showImagePopup && (
            <ImageModal
                isOpen={showImagePopup}
                imageSrcs={imageSrcs}
                startIndex={startIndex}
                caption={""}
                onClose={() => {
                    setShowImagePopup(false);
                    setImageSrcs([]);
                    setStartIndex(0);
                }}
                downloadImg={true} 
            />
            )}


        </>
    );
};

export default DamageReport;
